import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { colors, menuOffset } from "../../theme";
import { Offer, OfferTitle, OfferButton, More } from "./supportTheme";

function SupportSubscriptionOffer({ withButton }) {
  return (
    <Offer>
      <OfferTitle color={colors.green}>S'abonner</OfferTitle>
      <h3>À partir de 5€/mois</h3>
      {withButton && (
        <OfferButton as={Link} to="/soutien/abonnement">
          Je m'abonne
        </OfferButton>
      )}
      <ul style={{ minHeight: "271px" }}>
        <li>
          <i className="fa-fw fas fa-check" /> Soutenez financièrement Le Média
        </li>
        {/* <li>
          <i className="fa-fw fas fa-check" /> FAQ en direct avec des invités
        </li> */}
        <li>
          <i className="fa-fw fas fa-check" /> "Boîtes noires" sur nos sujets
        </li>
        <li>
          <i className="fa-fw fas fa-check" /> Recevez tous nos bonus
        </li>
        {/* <li>
          <i className="fa-fw fas fa-check" /> Donnez votre avis sur nos
          articles et émissions
        </li> */}
        {/* <li>
          <i className="fa-fw fas fa-check" /> Accédez en avance à nos sujets
        </li> */}
      </ul>
      {/* <div>
        <strong>-30%</strong> de crédit d’impôts sur l'abonnement annuel
      </div> */}
      {withButton && (
        <More
          to="ABONNEMENT"
          offset={-Math.abs(parseInt(menuOffset, 10) + 10)}
          isDynamic
          smooth
          duration={400}
        >
          En savoir plus
        </More>
      )}
    </Offer>
  );
}

SupportSubscriptionOffer.propTypes = {
  withButton: PropTypes.bool,
};

export default SupportSubscriptionOffer;
